export function renderAppSettings(settings) {
    if (!settings) {
        return '<p class="text-red-500">Failed to load settings.</p>';
    }

    return `
        <div class="space-y-4">
            ${settings.map(setting => `
                <div class="flex justify-between items-center">
                    <label class="text-gray-300" for="${setting.key}" data-setting-type="${setting.type}">${setting.description}</label>
                    ${renderInput(setting)}
                </div>
            `).join('')}
        </div>
    `;
}

/**
 * Dynamically renders the input element based on the setting type.
 * @param {Object} setting - The setting object with key, value, and type.
 * @returns {string} - The HTML string for the input element.
 */
function renderInput(setting) {
    switch (setting.type) {
        case 'boolean':
            return `
                <input
                    type="checkbox"
                    id="${setting.key}"
                    name="${setting.key}"
                    value="true"
                    data-key="${setting.key}"
                    class="rounded w-8 h-8 text-2xl dark:bg-gray-900 ${setting.type}"
                    ${setting.value === true ? 'checked' : ''}
                />
            `;
        case 'integer':
            return `
                <input
                    type="number"
                    id="${setting.key}"
                    name="${setting.key}"
                    value="${setting.value}"
                    step="0.01"
                    data-key="${setting.key}"
                    class="rounded w-20 text-lg text-center border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 xs:rounded-md shadow-sm"
                />
            `;
        case 'string':
        default:
            return `
                <input
                    type="text"
                    id="${setting.key}"
                    name="${setting.key}"
                    value="${setting.value || ''}"
                    data-key="${setting.key}"
                    class="rounded w-full text-lg p-2 border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 xs:rounded-md shadow-sm"
                />
            `;
    }
}
